<div class="dialog" fxLayout="column">

  <div mat-dialog-header>
    <div class="dialog-title" fxLayout="row" fxLayoutAlign="space-between end">
      <div fxLayout="row" fxLayoutGap="10px">
        <mat-icon>schedule</mat-icon>
        <span>{{'本番反映' | translate }}</span>
      </div>

      <div fxLayout="row" fxLayoutGap="10px">
        <button mat-raised-button color="primary" (click)="setSchedule()">
          <mat-icon>schedule</mat-icon>
          <span>{{'予約' | translate}}</span>
        </button>
        <button mat-raised-button color="warn" (click)="cancelSchedule()">
          <span>{{'予約取消' | translate}}</span>
        </button>
        <button mat-raised-button color="warn" (click)="reflectData()">
          <span>{{'即時実行' | translate}}</span>
        </button>
        <button mat-button (click)="cancel()">
          <mat-icon>clear</mat-icon>
        </button>
      </div>
    </div>
  </div>

  <div mat-dialog-content *ngIf="isLoad">
    <form [formGroup]="formGroup">
      <div class="dialog-body" fxLayout="column" fxLayoutGap="20px">
        <div>
          <mat-form-field>
            <input matInput [ngxMatDatetimePicker]="reserveDatePicker" placeholder="{{'実行予約日時' | translate}}" formControlName="reserveDate" readonly>
            <mat-datepicker-toggle matSuffix [for]="$any(reserveDatePicker)"z></mat-datepicker-toggle>
            <ngx-mat-datetime-picker #reserveDatePicker [showSeconds]="showSeconds"></ngx-mat-datetime-picker>
          </mat-form-field>
        </div>

        <div>
          <label>{{'予約設定日時：' | translate }}</label>
          <ng-container *ngIf="!!schedule.reserve_date">
            {{ schedule.reserve_date.toDate() | date:"yyyy-MM-dd HH:mm" }}
          </ng-container>
        </div>

        <div>
          <label>{{'前回本番反映日時：' | translate }}</label>
          <ng-container *ngIf="!!schedule.executed_date">
            {{ schedule.executed_date.toDate() | date:"yyyy-MM-dd HH:mm" }}
          </ng-container>
        </div>

        <div>
          <label>{{'本番反映ステータス：' | translate }}</label>
          {{ reflectStatus }}
        </div>

      </div>

    </form>
  </div>
</div>